import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ModalsModule } from 'src/app/features/modals/modals.module';
import { SharedModule } from 'src/app/features/shared';

import {
  CertificatePasswordLimitExceededComponent,
  CertificateValidationComponent,
  PinVerificationComponent,
} from './components';
import { PinValidationEffects } from './store/effects';
import { PinValidationReducers } from './store/reducers';

@NgModule({
  declarations: [
    CertificatePasswordLimitExceededComponent,
    CertificateValidationComponent,
    PinVerificationComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    StoreModule.forFeature(
      'pinValidation',
      PinValidationReducers.PinValidationReducer.pinValidationReducer
    ),
    EffectsModule.forFeature([PinValidationEffects.PinValidationEffects]),
    ModalsModule,
    SharedModule,
  ],
  exports: [CertificatePasswordLimitExceededComponent, CertificateValidationComponent],
})
export class PINValidationModule {}
